import { render, staticRenderFns } from "./OctagonPlusIcon.vue?vue&type=template&id=0c68260a"
import script from "./OctagonPlusIcon.vue?vue&type=script&lang=js"
export * from "./OctagonPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports